"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
class InstagramWidgetProps {
}
class InstagramWidget extends React.Component {
    componentDidMount() {
        this.processInstagramEmbeds();
    }
    componentDidUpdate() {
        this.processInstagramEmbeds();
    }
    processInstagramEmbeds() {
        try {
            if (window.instgrm && window.instgrm.Embeds) {
                window.instgrm.Embeds.process();
            }
        }
        catch (error) {
            console.warn('Instagram embed processing failed:', error);
        }
    }
    render() {
        return (React.createElement("div", { className: 'widget widget_flickr' },
            React.createElement("h4", null, "Instagram"),
            React.createElement("ul", { className: 'flickr' }, this.props.data.queryData && this.props.data.queryData.map((pic) => {
                return (React.createElement("li", { key: pic.id },
                    React.createElement("a", { target: '_blank', href: pic.link },
                        " ",
                        React.createElement("img", { className: 'img-responsive', src: pic.url, alt: 'instagram' }))));
            }))));
    }
}
exports.default = InstagramWidget;
